import React from "react";
import { Link } from "react-router-dom";
import logo from "../../icons/correla.svg";
import "./Home.css";

export default ({ hasProfile }) => (
  <section id="home">
    <div className="bg">
      <img src={logo} alt="Correla logo" className="bg-logo" />
    </div>
    <div className="home-top">
      <h2 className="home-headline">
        Find amazing people. <br className="headline-break" />
        Make new connections.
      </h2>
      <div className="home-links">
        <div className="home-link-c">
          <p className="home-link-description">
            Explore the directory and find people nearby.
          </p>
          <Link to="/search" className="home-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="home-link-icon"
            >
              <path d="M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z" />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
            <span>Discover</span>
          </Link>
        </div>
        <div className="home-link-c">
          {hasProfile ? (
            <p className="home-link-description">
              View, edit, and share your profile.
            </p>
          ) : (
            <p className="home-link-description">
              Join the community and create your profile.
            </p>
          )}
          <Link to="/account" className="home-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="home-link-icon"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
            </svg>
            <span>Connect</span>
          </Link>
        </div>
      </div>
    </div>
    <div className="home-bottom">
      <div className="exps">
        <div className="exp">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            viewBox="0 0 100 100"
            className="icon exp-icon"
          >
            <circle cx="27.1" cy="26.3" r="8.7" />
            <path d="M46,20c-1.8-0.1-3.4,1.3-3.5,3.1c-0.2,3.1-1.2,8.4-2.8,10.3c-1.4,1.7-5,3.7-6.8,3.7h-11c-3.5,0-5.2,2.1-6.4,4     c-0.3,0.5-0.8,1.1-1.3,1.8c-1.5,2-3.1,4.2-3.7,6.1c-0.6,2-3,8.6-3,8.6c-0.6,1.7,0.3,3.6,2,4.3c0.4,0.1,0.8,0.2,1.1,0.2     c1.4,0,2.6-0.8,3.1-2.2c0.1-0.3,2.5-6.8,3.1-8.9c0.2-0.7,1.2-2.1,2.1-3.3l-0.6,13L9,92.3c-0.6,2.1,0.6,4.4,2.7,5     c0.4,0.1,0.8,0.2,1.1,0.2c1.7,0,3.4-1.1,3.9-2.9l7.9-26.9l-0.6,25.7c0,2.2,1.7,4.1,3.9,4.1c2.2,0.1,4.1-1.7,4.1-3.9L32.8,62     l1.6-18.4c3.9-0.7,8.2-3.4,10.4-6.1c3.5-4.3,4.2-13.1,4.2-14C49.2,21.7,47.8,20.2,46,20z" />
            <circle cx="72.9" cy="26.3" r="8.7" />
            <path d="M83.2,51.2c0.7,2.1,3,8.6,3.1,8.9c0.5,1.3,1.8,2.2,3.1,2.2c0.4,0,0.8-0.1,1.1-0.2c1.7-0.6,2.6-2.5,2-4.3     c0-0.1-2.4-6.6-3-8.6c-0.6-2-2.3-4.2-3.7-6.1c-0.5-0.7-1-1.4-1.3-1.8c-1.2-1.9-3-4-6.4-4h-11c-1.8,0-5.4-2-6.8-3.7     c-1.6-1.9-2.6-7.2-2.8-10.3c-0.1-1.8-1.7-3.2-3.5-3.1c-1.8,0.1-3.2,1.7-3.1,3.5c0.1,1,0.8,9.7,4.2,14c2.1,2.6,6.5,5.4,10.4,6.1     L67.2,62l0.7,31.5c0,2.2,1.8,4,4.1,3.9c2.2,0,4-1.9,3.9-4.1l-0.6-25.7l7.9,26.9c0.5,1.8,2.1,2.9,3.9,2.9c0.4,0,0.8-0.1,1.1-0.2     c2.1-0.6,3.4-2.9,2.7-5l-9.2-31.5l-0.6-13C82,49,83,50.5,83.2,51.2z" />
            <path d="M51.8,10.7V4.3c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8v6.4c0,1,0.8,1.8,1.8,1.8S51.8,11.7,51.8,10.7z" />
            <path d="M41.3,15.1c0.3,0.4,0.8,0.5,1.3,0.5c0.5,0,0.9-0.2,1.3-0.5c0.7-0.7,0.7-1.8,0-2.5L39.3,8c-0.7-0.7-1.8-0.7-2.5,0     s-0.7,1.8,0,2.5L41.3,15.1z" />
            <path d="M57.4,15.6c0.5,0,0.9-0.2,1.3-0.5l4.5-4.5c0.7-0.7,0.7-1.8,0-2.5c-0.7-0.7-1.8-0.7-2.5,0l-4.5,4.5     c-0.7,0.7-0.7,1.8,0,2.5C56.5,15.4,57,15.6,57.4,15.6z" />
          </svg>
          <p className="exp-text">
            Meet your next friend, partner, mentor, teammate, or connection.
          </p>
        </div>
        <div className="exp">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            viewBox="0 0 100 100"
            className="icon exp-icon"
          >
            <path d="M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z" />
            <path d="M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z" />
            <path d="M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z" />
            <path d="M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z" />
            <path d="M50.8,44.9c-2,1-4.3,1.6-6.7,1.6c-2.5,0-4.7-0.6-6.8-1.7c-3.9,1.2-6.8,4.5-7.4,8.8l-0.8,6.1c-0.2,1.3,0.9,2.5,2.2,2.5     h25.4c1.3,0,2.3-1.1,2.2-2.5l-0.7-6.1C57.6,49.4,54.7,46.1,50.8,44.9z" />
            <circle cx="44.1" cy="31.8" r="9.9" />
            <path d="M96,88.6L76.8,69.4c5.5-7,8.7-15.8,8.7-25.4C85.6,21.1,66.9,2.5,44,2.5S2.5,21.1,2.5,44S21.1,85.6,44,85.6     c9.6,0,18.4-3.3,25.4-8.7L88.6,96c1,1,2.4,1.5,3.7,1.5c1.3,0,2.7-0.5,3.7-1.5C98,93.9,98,90.6,96,88.6z M13,44     C13,26.9,26.9,13,44,13S75.1,26.9,75.1,44S61.2,75.1,44,75.1S13,61.2,13,44z" />
          </svg>
          <p className="exp-text">
            Search for people in your city based on their self-defining
            "identities".
          </p>
        </div>
        <div className="exp">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            viewBox="0 0 100 100"
            className="icon exp-icon"
          >
            <path d="M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z" />
            <path d="M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z" />
            <path d="M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z" />
            <path d="M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z" />
            <path d="M56.5,37h2.8c1.3,1.7,3.8,4.5,6.6,6c0.2,0.1,0.5,0.1,0.7,0.1c0.4,0,0.8-0.1,1.1-0.4c0.5-0.5,0.6-1.1,0.3-1.7     c-0.7-1.5-0.9-3-0.9-4h1.5c1.7,0,3.1-1.4,3.1-3.1V21.3c0-1.7-1.4-3.1-3.1-3.1H49.9c-1.7,0-3.1,1.4-3.1,3.1v2.6h3.4     c3.5,0,6.3,2.9,6.3,6.4V37z" />
            <path d="M50.1,27.2H31.3c-1.7,0-3.1,1.4-3.1,3.1v12.6c0,1.7,1.4,3.1,3.1,3.1h1.6c0,1.1-0.2,2.5-0.9,4c-0.3,0.6-0.1,1.2,0.3,1.7     c0.3,0.3,0.7,0.4,1,0.4c0.2,0,0.5-0.1,0.7-0.2c2.9-1.4,5.3-4.2,6.6-6h9.5c1.7,0,3.1-1.4,3.1-3.1V30.3     C53.2,28.6,51.8,27.2,50.1,27.2z" />
            <path d="M40.2,59.1c-3.3,0.7-9.1,1.5-11.1,0.8c-0.8-0.4-3-2.7-4.1-4c-1.1-1.2-2.1-2.3-3.1-3.2c-1.6-1.6-3-2.8-5.4-3.4     c-2.9-0.7-10.2-1.6-12.3,3.2c-2.2,5.1-1.8,18.3-1.7,27.7c0,0.8,0.5,1.5,1.4,1.5c2,0,14.6,0,15.6,0c0.9,0,1.3-0.5,1.4-1.3     C21,80,21.5,71,21.8,64.6c1.5,1.4,3,2.6,4.6,3.1c1.5,0.5,3.4,0.7,5.3,0.7c4.4,0,9.1-1,10.3-1.3c2.2-0.5,3.6-2.7,3.1-5     C44.6,60,42.4,58.6,40.2,59.1z" />
            <circle cx="13.3" cy="37.1" r="9.5" />
            <path d="M95.7,52.6c-2-4.8-9.4-4-12.3-3.2c-2.4,0.6-3.7,1.8-5.4,3.4c-1,0.9-2,2-3.1,3.2c-1.1,1.3-3.2,3.6-4.1,4     c-2,0.7-7.9-0.1-11.1-0.8c-2.2-0.5-4.5,0.9-5,3.1c-0.5,2.2,0.9,4.5,3.1,5c1.2,0.3,5.9,1.3,10.3,1.3c1.9,0,3.7-0.2,5.3-0.7     c1.6-0.5,3.1-1.7,4.6-3.1C78.5,71,79,80,79.1,80.5c0.1,0.8,0.4,1.3,1.4,1.3c0.9,0,13.6,0,15.6,0c0.8,0,1.4-0.6,1.4-1.5     C97.5,70.9,97.9,57.7,95.7,52.6z" />
            <circle cx="86.7" cy="37.1" r="9.4" />
          </svg>
          <p className="exp-text">
            Start conversations through your preferred websites and social
            media.
          </p>
        </div>
      </div>
    </div>
  </section>
);
